import Axios from 'axios'
import posthog from 'posthog-js'

import Store from '@/store'

import Package from '../../package.json'
import {configuration} from '../../configuration'

import Auth from '../modules/auth'
import Tag from '../modules/tag'
import Storage from '../helpers/storage'

export default {

    get(url, headers) {

        return Axios({
            method: 'get',
            headers: baseHeaders(headers),
            url: reworkUrl(url),
            data: {}
        })
            .then(response => treatResponse(response))
            .then(response => response.data)
            .catch(error => treatError(error))
    },

    post(url, data = {}, headers) {

        return Axios({
            method: 'post',
            headers: baseHeaders(headers),
            url: reworkUrl(url),
            data: data
        })
            .then(response => treatResponse(response))
            .then(response => response.data)
            .catch(error => treatError(error))
    },

    put(url, data, headers) {

        return Axios({
            method: 'put',
            headers: baseHeaders(headers),
            url: reworkUrl(url),
            data: data
        })
            .then(response => treatResponse(response))
            .then(response => response.data)
            .catch(error => treatError(error))
    },

    delete(url, headers) {

        return Axios({
            method: 'delete',
            headers: baseHeaders(headers),
            url: reworkUrl(url),
            data: {}
        })
            .then(response => treatResponse(response))
            .then(response => response.data)
            .catch(error => treatError(error))
    },

    web: {

        post(url, data, headers) {

            return Axios({
                url: url,
                method: 'post',
                headers: headers,
                data: data
            })
        }
    }

}

function base(url) {
    return configuration.url.server + url
}

function reworkUrl(url) {
    const device = 'web'
    const version = Package.version
    const queryInfos = `device=${device}&version=${version}`
    const reworkedUrl = url.indexOf('?') > -1
        ? `${url}&${queryInfos}`
        : `${url}?${queryInfos}`

    return base(reworkedUrl)
}

function getToken() {
    return localStorage.getItem('token') || ''
}

function baseHeaders(headers) {
    return {'x-access-token': getToken(), 'content-type': 'application/json', ...headers}
}

function treatResponse(response) {
    Store.dispatch('setInternetStatus', true)
    return response
}

async function treatError(error) {
    if (posthog && posthog.__loaded) {
        posthog.captureException(error)
    }
    if(!Store.getters.internet) {
        throw { message: 'Network Error' }
    } else if (error.toString() === 'Error: Network Error') {
        Store.dispatch('setInternetStatus', false)
        throw { message: 'Network Error' }
    }

    const { status, message, data } = formatError(error)

    switch (status) {
        case 400:
            if (message === 'maintenance') {
                Store.dispatch('setMaintenance', true)
                break
            }
            throw { message, data }
        case 401:
            if(Storage.getItem('token')) {
                // don't refresh page if is not connected, so no disconnect if is not connected
                Auth.disconnect()
            }
            break
        case 500:
            Tag.errorAmplitude(this, 'error 500')
            throw { message, data }
    }
}

function formatError(error) {
    if (error) {
        if (error.response) {

            return  { status: error.response.status || 500, message: error.response.data.message || '', data: error.response.data.data || null }
        }

        if (error.status) {
            return { status: error.status || 500, message: error.message || '', data: error.data || null }
        }
    }

    throw error
}
